import type { FC } from 'react'
import { ListItem, ListItemAvatar, ListItemText, Skeleton } from '../primitives/index.js'
import styles from './list-item-skeleton.module.css'

export interface ListItemSkeletonProps {}

export const ListItemSkeleton: FC<ListItemSkeletonProps> = () => (
  <ListItem className={styles.listItem}>
    <ListItemAvatar>
      <Skeleton className={styles.skeleton} variant="circular" width={40} height={40} />
    </ListItemAvatar>
    <ListItemText>
      <Skeleton animation="wave" width="100%" height={60} variant="rectangular" />
    </ListItemText>
  </ListItem>
)

export default ListItemSkeleton
